module.exports = __webpack_public_path__ + "img/0Q3A7692_L_BlackMatted_MockedUp.06b4501c.jpg";